module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.divClassName ? _vm.divClassName : ''
  }, [(_vm.isTikTok) ? _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.tiktokHandle))]) : _vm._e(), _vm._v(" "), (_vm.isInstagram) ? _c('span', [_c('v-icon', {
    staticClass: "social-handle-view__instagram",
    attrs: {
      "color": "#E1306C",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.instagramHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isFacebook) ? _c('span', [_c('v-icon', {
    staticClass: "social-handle-view__facebook",
    attrs: {
      "color": "#1877F2",
      "small": ""
    }
  }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(_vm.facebookHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isLinkedIn) ? _c('span', [_c('v-icon', {
    staticClass: "social-handle-view__linkedin",
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.linkedinHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isTwitter) ? _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" @" + _vm._s(_vm.twitterHandle))]) : _vm._e(), _vm._v(" "), (_vm.isYoutube) ? _c('span', [_c('v-icon', {
    staticClass: "social-handle-view__youtube",
    attrs: {
      "color": "#FF0000",
      "small": ""
    }
  }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.youtubeHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isXiaohongshu) ? _c('span', [_c('img', {
    staticStyle: {
      "border-radius": "15%"
    },
    attrs: {
      "src": "/static/img/xhs-black.png",
      "width": "15px"
    }
  }), _vm._v(" " + _vm._s(_vm.xiaohongshuFullName || _vm.xiaohongshuHandle))]) : _vm._e(), _vm._v(" "), (_vm.isOthers) ? _c('span', [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-help-circle")]), _vm._v(" " + _vm._s(_vm.otherHandle))], 1) : _vm._e(), _vm._v(" "), (!_vm.hasExplicitPlatform && _vm.otherHandle) ? _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "X"
    }
  }), _vm._v(" @" + _vm._s(_vm.otherHandle))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92e6da4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/custom/SocialHandleView.vue
// module id = 2236
// module chunks = 0